import React from 'react';
import { useGoogleTranslator } from '@/hooks';

interface Props {
  children: React.ReactNode;
}

export const Translate: React.FC<Props> = ({ children: value }) => {
  const textTranslated = useGoogleTranslator(value as string);

  return <>{textTranslated}</>;
};
